import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Load Stripe with your publishable key from environment variable
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function EmbeddedPayment() {
  const location = useLocation();
  const navigate = useNavigate();
  const [clientSecret, setClientSecret] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const bookingId = new URLSearchParams(location.search).get('booking_id');

  useEffect(() => {
    if (!bookingId) {
      setError('No booking ID provided');
      setLoading(false);
      return;
    }

    // Fetch the client secret from your backend
    const fetchClientSecret = async () => {
      try {
        const response = await axios.post(`${API}/api/payments/checkout`, {
          booking_id: bookingId,
          origin_url: window.location.origin
        });
        
        setClientSecret(response.data.clientSecret);
        setLoading(false);
      } catch (err) {
        console.error('Payment setup error:', err);
        setError('Failed to initialize payment. Please try again.');
        setLoading(false);
      }
    };

    fetchClientSecret();
  }, [bookingId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500 mx-auto mb-4"></div>
          <p className="text-white">Setting up payment...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900 flex items-center justify-center p-4">
        <div className="bg-zinc-800 border border-zinc-700 rounded-xl p-8 max-w-md text-center">
          <p className="text-red-400 mb-4">{error}</p>
          <button
            onClick={() => navigate('/book')}
            className="px-6 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600"
          >
            Back to Booking
          </button>
        </div>
      </div>
    );
  }

  const options = { clientSecret };

  return (
    <div className="min-h-screen bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-zinc-800 border border-zinc-700 rounded-xl p-8">
          <h1 className="text-3xl font-bold text-white mb-2">Complete Payment</h1>
          <p className="text-zinc-400 mb-8">Secure payment powered by Stripe</p>
          
          <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
            <EmbeddedCheckout />
          </EmbeddedCheckoutProvider>
        </div>
      </div>
    </div>
  );
}
